import {create} from "@/api/rest";

const captcha = {
    verifyToken: async (data) => await create('/captcha/verify-token', data),
};

export default captcha;